import { useMutation, useQuery } from "@tanstack/react-query";
import { useInvalidateTransactionOrder } from "./transaction";
import {
  createSipTransactionApi,
  deleteSipTransactionApi,
  getNextStepupDate,
  getSipStats,
  modifySipTransactionApi,
  updateSipTransactionApi,
} from "../../api/transaction/sip";
import { useInvalidateSip } from "../client";

export const useCreateSipTransactionV2 = () => {
  return useMutation({
    mutationFn: createSipTransactionApi,
  });
};

export const useCreateSipTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/sip/create"],
    mutationFn: createSipTransactionApi,
    onSuccess: invalidate,
  });
};

export const useUpdateSipTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/sip/update"],
    mutationFn: updateSipTransactionApi,
    onSuccess: invalidate,
  });
};

export const useDeleteSipTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateSip(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/sip/delete"],
    mutationFn: deleteSipTransactionApi,
    onSuccess: invalidate,
  });
};

export const useModifySipTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/sip/update"],
    mutationFn: modifySipTransactionApi,
    onSuccess: invalidate,
  });
};

export const useSipStats = (investmentAccountId: string) => {
  return useQuery({
    queryKey: ["sip-stats", investmentAccountId],
    queryFn: () => getSipStats(investmentAccountId),
  });
};

export const useNextStepupInstallmentDate = (
  variables: Parameters<typeof getNextStepupDate>[0],
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: [
      "next-sip-step-up-date",
      variables.nextInstallmentDate,
      variables.frequency,
      variables.stepUpFrequency,
    ],
    queryFn: () => getNextStepupDate(variables),
    ...options,
  });
};
